export default "__VITE_ASSET__8Lmj7ox0__"